import { h } from "preact";

import { classNames } from "../helpers";
import RadioButton from "./RadioButton.jsx";
import Tooltip from "./Tooltip.jsx";

export default function RadioButtonGroup(props) {
  return (
    <div
      role="radiogroup"
      class={classNames(
        "radio-button-group",
        props.class,
        props.boxed && "collection",
        props.boxed && "radio-button-group--boxed",
        props.error && "radio-button-group--invalid",
        props.twoColumns && "radio-button-group--two-col"
      )}
      id={props.id}
    >
      <div class="radio-button-group__items">
        {props.items.map(({ value, label, description, tooltip }) => (
          <RadioButton
            boxed={props.boxed}
            class={classNames("radio-button-group__item")}
            value={value}
            name={props.name}
            checked={props.value === value}
            description={description}
            onChange={props.onChange || props.onInput}
          >
            <span data-tooltip-id={`tooltip-${value}`}>{label}</span>
            {tooltip && (
              <Tooltip
                className="nioomi-tooltip"
                id={`tooltip-${value}`}
                place="bottom"
              >
                {tooltip}
              </Tooltip>
            )}
          </RadioButton>
        ))}
      </div>
      {props.error && (
        <span class="radio-button-group__helper-text">{props.error}</span>
      )}
    </div>
  );
}
